import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import {Dialog, DialogActions, DialogContent, DialogTitle} from '@material-ui/core'
import {Container, Box} from '@material-ui/core'
import {Button, FormControl, Checkbox, InputLabel, Select, MenuItem} from '@material-ui/core';
import { getPermissionsArray, getPermissionsFromArray } from '../../../api/helpers';

class EditDispatcherPermissionsDialog_ extends React.Component{

    constructor(props){
        super(props)

        console.log('EditDispatcherPermissionsDialog props')
        console.log(props)

        let permissions = this.props.permissions

        /*
        let permissionsArr = new Array(37)
        for(let i = 0; i < 37; ++i){
            permissionsArr[i] = (permissions >> i) & 1;
        }
        console.log('construct permissionsArr')
        console.log(permissionsArr)
        */
        //let arr = getPermissionsArray(4294967296+1)

        //console.log('permissions')
        //console.log(permissions)

        let permissionsArr = getPermissionsArray(permissions)
        //console.log('permissionsArr')
        //console.log(permissionsArr)

        this.state = {
            changed: false,
            permissions: permissionsArr,
            errors: {}
        }
    }

    handleSave(){
        if(this.validate()){

            let permissions = 0
            let permissionsArr = this.state.permissions // Array(38)

            /*
            for(let i = 0; i < 37; ++i){
                permissions += permissionsArr[i] << i;
            }
            */

            permissions = getPermissionsFromArray(permissionsArr)

            //console.log('handleSave permissionsArr')
            //console.log(permissionsArr)
            //console.log(permissions)

            this.props.onAction({type: 'DISPATCHER_PERMISSIONS_EDITOR_SAVE', permissions: permissions})
        }
    }

    handleClose(){
        if(this.state.changed){
            this.props.onAction({
                type: 'CONFIRM_DIALOG', 
                message: this.props.t('CloseFormConfirm'),
                onConfirm: ()=>{
                    this.props.onAction({type: 'DISPATCHER_PERMISSIONS_EDITOR_CLOSE'})
                }
            })
        }else{
            this.props.onAction({type: 'DISPATCHER_PERMISSIONS_EDITOR_CLOSE'})
        }
    }

    handleInput(event){
        let changed = {}
        if(!this.state.changed) changed = {changed: true}

        let permissions = this.state.permissions

        console.log('handleInput event.target.name '+ event.target.name)
        switch(event.target.name){
            case 'PresenceMode':
                //console.log('set presenceMode = '+event.target.value)
                let flag_13 =  event.target.value & 1
                let flag_14 =  (event.target.value >> 1) & 1
                //console.log('flag_13 event.target.value >> 1 ='+ (event.target.value >> 1))
                //console.log('flag_14 (event.target.value >> 1) & 1 ='+ ((event.target.value >> 1) & 1))
                //console.log('flag_13 = '+flag_13)
                //console.log('flag_14 = '+flag_14)
                permissions[13] = flag_13
                permissions[14] = flag_14
            break;

            default:
                //console.log('permissions')
                //console.log(permissions)
                let arr = event.target.name.split('_')
                let i = arr[1]
                permissions[i] = event.target.checked
        }

        this.setState({permissions: permissions, ...changed})
    }

    getPresenceMode(){
        //console.log('getPresenceMode')
        //console.log('11:'+this.state.permissions[13])
        //console.log('12:'+this.state.permissions[14])
        let presenceMode = this.state.permissions[13]+this.state.permissions[14]*2
        //console.log('get presenceMode = '+presenceMode)
        return presenceMode
    }

    validate(){
        //let errors = this.state.errors;
        let error = false
  /*   
        if(!this.state.group.Name){
            errors.Name = 'Name is empty'
            error = true
        }else{
            errors.Name = false
        }
        this.setState({errors: errors})
*/
        return !error;
    }


    render(){
        const {t} = this.props

        const title = t('DispatcherPermissions')

        const margin = {margin:'16px 0 8px 0'}

        console.log('this.state.permissions')
        console.log(this.state.permissions)

        return(
<Dialog
    scroll="body"
    fullWidth={this.props.fullWidth}
    maxWidth={this.props.maxWidth}
    open={this.props.open}
    onClose={this.handleClose.bind(this)}
    aria-labelledby="edit-dialog-title">
        
    <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
    <DialogContent>
        <form>
        <Container maxWidth="lg" style={{minWidth:300}}>
            {/*console.log('permissions_21')*/}
            {/*console.log(this.state.permissions[21])*/}
            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[21]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_21"
                            />
                            {t('ManageUsersAndGroups')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[24]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_24"
                            />
                            {t('ManageDeviceSettings')}
                    </label>
                </FormControl>
            </Box>

            {this.props.monitoringEnabled ? 
            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[22]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_22"
                            />
                            {t('Monitoring')}
                    </label>
                </FormControl>
            </Box>
            :''}

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[4]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_4"
                            />
                            {t('AllowPTTVideoCalls')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[32]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_32"
                            />
                            {t('RestritPeriodicLocationRequests')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[33]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_33"
                            />
                            {t('RestrictLocationTrackReport')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[23]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_23"
                            />
                            {t('CallRecordingReport')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[27]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_27"
                            />
                            {t('EmergencyReport')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[30]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_30"
                            />
                            {t('UserInventoryReport')}
                    </label>
                </FormControl>
            </Box>

            
            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[28]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_28"
                            />
                            {t('GuardTour')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[29]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_29"
                            />
                            {t('GroupPatches')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[34]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_34"
                            />
                            {t('DynamicGroups')}
                    </label>
                </FormControl>
            </Box>

            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[35]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_35"   
                            />
                            {t('ManageAllDynamicGroups')}
                    </label>
                </FormControl>
            </Box>

            {this.props.indoorTrackingEnabled ? 
            <Box textAlign="" style={{...margin, width: '100%'}}>
                <FormControl>
                    <label>
                        <Checkbox color="primary" 
                            checked={this.state.permissions[38]}
                            onChange={this.handleInput.bind(this)}
                            name="permissions_38"   
                            />
                            {t('IndoorTracking')}
                    </label>
                </FormControl>
            </Box>
            :''}

            <Box textAlign="left">
                <FormControl style={{...margin, width: '100%'}}>
                    <InputLabel htmlFor="PresenceMode">{t('PresenceMode')}</InputLabel>
                    <Select
                        value={this.getPresenceMode()}
                        onChange={this.handleInput.bind(this)}
                        inputProps={{
                            name: 'PresenceMode',
                            id: 'PresenceMode',
                        }}
                        >
                        <MenuItem key="0" value={0}>{t('AllUsers')}</MenuItem>
                        <MenuItem key="1" value={1}>{t('OnlyGroupMembers')}</MenuItem>
                        <MenuItem key="2" value={2}>{t('OnlyGroups')}</MenuItem>
                        <MenuItem key="3" value={3}>{t('OnlyGroupsAndDispatchers')}</MenuItem>

                    </Select>
                </FormControl>
            </Box>

        </Container>
        </form>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.handleSave.bind(this)} variant="contained" color="primary">
            {t('Apply')}
        </Button>
        <Button onClick={this.handleClose.bind(this)} variant="contained" color="inherit">
            {t('Cancel')}
        </Button>
    </DialogActions>

</Dialog>
        );

    }
}

export const EditDispatcherPermissionsDialog = withTranslation()(EditDispatcherPermissionsDialog_);